import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";

export type NotificationReasonCode =
    | 'AVAILABLE'
    | 'REPORTS_NOT_PUBLISHED'
    | 'ALREADY_SENT'
    | 'PREVIOUS_ATTEMPT_FAILED'
    | 'OPERATION_IN_PROGRESS'
    | 'NO_RECIPIENTS';

export interface NotificationResult {
    status: string;
    message: string;
    sentAt: string;
    sentBy: string;
    recipientCount: number;
    gatewayMessageId: string;
}

export interface NotificationStatus {
    available: boolean;
    reasonCode: NotificationReasonCode;
    reportingPeriod: string;
    notificationResult: NotificationResult | null;
}

@Injectable({
    providedIn: 'root'
})
export class UserNotificationService {
    private http = inject(HttpClient);
    
    private readonly notificationEndpoint = {
        getNotificationStatus: '/notification/monthly-report/status',
        sendNotification: '/notification/monthly-report/send',
    }

    getNotificationStatus() {
        return this.http.get<NotificationStatus>(this.notificationEndpoint.getNotificationStatus);
    }

    sendNotification() {
        return this.http.post<NotificationResult>(this.notificationEndpoint.sendNotification, null);
    }
}
